import { ON_PROCESS_STT } from "@/app/infrastructures/misc/RolePermission";
import { FlagsPermissionOnProcessstt } from "@/feature-flags/flags-permission-on-process-stt";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const DetailBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/detail-booking/detail.vue"
  );
const EditBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-edit-booking/index.vue"
  );
const EditBookingV3 = () =>
  import(
    /* webpackChunkName: "InstantBooking" */ "@/app/ui/views/shipment/booking/create-booking-v3/edit-booking.vue"
  );
const EditBookingV4 = () =>
  import(
    /* webpackChunkName: "EditBookingV4" */ "@/app/ui/views/shipment/booking/create-booking-v4/edit-booking.vue"
  );

export default [
  {
    path: "/shipment/on-process-stt",
    component: Layout,
    name: "shipment-on-process-stt-detail",
    meta: {
      title: "Shipment On Process STT | Detail",
      hidden: true,
      parent: "On Process STT",
      permission: FlagsPermissionOnProcessstt.on_process_stt_detail_edit
    },
    children: [
      {
        path: ":id",
        name: "detail-on-process-stt",
        component: DetailBooking,
        meta: {
          header: true,
          customPath: "on-process-stt",
          isAuth: false,
        }
      }
    ]
  },
  {
    path: "/shipment/on-process-stt",
    component: Layout,
    name: "shipment-on-process-stt-edit",
    meta: {
      title: "Shipment On Process STT | Edit",
      hidden: true,
      parent: "On Process STT",
      permission: FlagsPermissionOnProcessstt.on_process_stt_detail_edit
    },
    children: [
      {
        path: ":id/edit",
        name: "bookingV3.edit.title",
        component: EditBooking,
        meta: {
          header: true,
          name: "bookingV3.edit.title",
          title: "bookingV3.edit.pageTitle",
          customPath: "on-process-stt",
          isAuth: false
        }
      }
    ]
  },
  {
    path: "/shipment/on-process-stt",
    component: Layout,
    name: "shipment-on-process-stt-edit-v3",
    meta: {
      title: "Shipment On Process STT | Edit",
      hidden: true,
      parent: "On Process STT",
      permission: FlagsPermissionOnProcessstt.on_process_stt_detail_edit
    },
    children: [
      {
        path: ":id/edit-v3",
        name: "edit-on-process-stt-v3",
        component: EditBookingV3,
        meta: {
          header: true,
          name: "bookingV3.edit.title",
          title: "bookingV3.edit.pageTitle",
          customPath: "on-process-stt",
          isAuth: false,
        }
      }
    ]
  },
  {
    path: "/shipment/on-process-stt",
    component: Layout,
    name: "shipment-on-process-stt-edit-v4",
    meta: {
      title: "bookingV3.edit.title",
      hidden: true,
      parent: "On Process STT",
      permission: FlagsPermissionOnProcessstt.on_process_stt_detail_edit
    },
    children: [
      {
        path: ":id/edit-v4",
        name: "edit-on-process-stt-v4",
        component: EditBookingV4,
        meta: {
          header: true,
          name: "bookingV3.edit.title",
          title: "bookingV3.edit.title",
          customPath: "on-process-stt",
          isAuth: false
        }
      }
    ]
  }
];
